import {usePrevious} from '@react-hookz/web';

import {PreviousPageProviderContext} from '@/modules/common/context/PreviousPage/context';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

export const PreviousPageProvider = ({children}: React.PropsWithChildren) => {
  const previousPage = usePrevious(useCurrentPage()) ?? null;

  return (
    <PreviousPageProviderContext.Provider value={previousPage}>
      {children}
    </PreviousPageProviderContext.Provider>
  );
};
